import { render, staticRenderFns } from "./QRCodePayment.vue?vue&type=template&id=5b9d2194&scoped=true"
import script from "./QRCodePayment.vue?vue&type=script&lang=js"
export * from "./QRCodePayment.vue?vue&type=script&lang=js"
import style0 from "./QRCodePayment.vue?vue&type=style&index=0&id=5b9d2194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9d2194",
  null
  
)

export default component.exports